import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';
export class VehicleDetailsTabRequestsComponent extends ABaseComponent {
    constructor(logger, ui, dss, dialog, helperService, auth) {
        super(logger);
        this.logger = logger;
        this.ui = ui;
        this.dss = dss;
        this.dialog = dialog;
        this.helperService = helperService;
        this.auth = auth;
    }
    set vehicleService(v) {
        this._vehicleService = v;
        this.changeHandle();
    }
    get vehicleService() {
        return this._vehicleService;
    }
    changeHandle() { }
    resolveRequest(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                request.resolvedAt = new Date();
                const { requests } = this.vehicleService;
                const index = requests.findIndex((rep) => rep.id === request.id);
                if (index !== -1) {
                    requests[index] = Object.assign({}, requests[index], { resolvedAt: request.resolvedAt });
                    const { requests: updatedRequests } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { requests })
                        .toPromise();
                    this.vehicleService.requests = updatedRequests;
                    notify('Request resolved successfully', 'success', 3000);
                }
            }
            catch (error) {
                notify('Error resolving request', 'error', 3000);
                console.error('Error resolving request:', error);
            }
        });
    }
    onRequestInserting(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                event.data.id = event.data.__KEY__;
                event.data.createdAt = new Date();
                event.data.requiresService = event.data.requiresService || false;
                event.data.allowOperation = event.data.allowOperation || false;
                const { id, username } = this.auth.getCurrentUserData();
                event.data.createdBy = { id, username };
                let { requests } = this.vehicleService;
                requests = [Object.assign({}, event.data, { __KEY__: undefined }), ...this.vehicleService.requests];
                this.vehicleService.requests = requests; // Update the local state with predicted data
                // Call the API to add the new request
                const updatedVehicleService = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { requests })
                    .toPromise();
                // Update the local state with the response
                this.vehicleService.requests = updatedVehicleService.requests;
            }
            catch (error) {
                notify('Error inserting request', 'error', 3000);
                console.error('Error inserting request:', error);
                event.cancel = true;
            }
        });
    }
    onRequestUpdating(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { requests } = this.vehicleService;
                const index = requests.findIndex((rep) => rep.id === event.key.id);
                if (index !== -1) {
                    requests[index] = Object.assign({}, requests[index], event.newData, { updatedAt: new Date() });
                    const { requests: updatedRequests } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { requests })
                        .toPromise();
                    this.vehicleService.requests = updatedRequests;
                }
            }
            catch (error) {
                notify('Error updating request', 'error', 3000);
                console.error('Error updating request:', error);
                event.cancel = true;
            }
        });
    }
    onRequestRemoving(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { requests } = this.vehicleService;
            const index = requests.findIndex((rep) => rep.id === event.key.id);
            if (index !== -1) {
                requests.splice(index, 1);
                const { requests: updatedRequests } = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { requests })
                    .toPromise();
                this.vehicleService.requests = updatedRequests;
            }
        });
    }
}
